import { FormikProps } from 'formik';
import RowOfStatement from './RowOfStatement';
import IbanField from './IbanField';
import { IBAN_PLACEHOLDER } from '../helpers/iban';
import { FormValues } from '../FormPagePerson';
import { useLanguage } from '../i18n/LanguageContext';

// Rachunek do wypłaty wynagrodzenia. Sekcja niezależna od oświadczeń ZUS —
// jest potrzebna zawsze, niezależnie od ZUS_STATEMENTS_ENABLED.
const SettlementData = ({ formik }: { formik: FormikProps<FormValues> }) => {
    const { t } = useLanguage();
    return (
        <RowOfStatement
            formik={formik}
            title={t('field.iban')}
            name="accountNumber"
            input={
                <IbanField
                    sx={{ maxWidth: 600 }}
                    value={formik.values.accountNumber}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder={IBAN_PLACEHOLDER}
                    setValue={(v) => formik.setFieldValue('accountNumber', v)}
                    error={formik.touched.accountNumber && Boolean(formik.errors.accountNumber)}
                    helperText={formik.touched.accountNumber && formik.errors.accountNumber}
                />
            }
        />
    );
};

export default SettlementData;
